import { render } from "./TopNavigationBar.vue?vue&type=template&id=98931278&scoped=true&ts=true"
import script from "./TopNavigationBar.vue?vue&type=script&lang=ts"
export * from "./TopNavigationBar.vue?vue&type=script&lang=ts"

import "./TopNavigationBar.vue?vue&type=style&index=0&id=98931278&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98931278"]])

export default __exports__